import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { catchError, map, Observable, Subject, throwError } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class VesselService {
  private API_URL = environment.apiUrl;

  private primaryVesselChangedSource = new Subject<void>();
  primaryVesselChanged$ = this.primaryVesselChangedSource.asObservable();

  triggerPrimaryRefresh() {
    this.primaryVesselChangedSource.next();
  }

  constructor(private http: HttpClient) { }

  createVessel(formData: FormData) {
    return this.http.post(`${this.API_URL}/vessel/`, formData);
  }

  getVessels() {
    return this.http.get(`${this.API_URL}/vessel/`);
  }
  getLatestObservation(vesselId: string): Observable<any> {
    return this.http
      .get(`${this.API_URL}/observations/latest?vessel_id=${vesselId}`)
      .pipe(catchError((err) => throwError(() => err)));
  }
  // Returns the most recent lat/lon from the latest observation.
  // Finds all GNSSPositionData PGNs, sorts by ts_utc (newest first),
  // and returns { lat, lon, ts } of the most recent one.
  // Emits null if no observation or no GNSS data is found.
  getLatestCoords(
    vesselId: string,
  ): Observable<{ lat: number; lon: number; ts: string } | null> {
    return this.getLatestObservation(vesselId).pipe(
      map((obs: any) => {
        if (!obs?.pgns) return null;

        const gnssPgns = (obs.pgns as any[])
          .filter(
            (p) =>
              p.name === 'GNSSPositionData' &&
              p.fields?.lat_deg != null &&
              p.fields?.lon_deg != null,
          )
          .sort((a, b) => {
            const tsA = a.ts_utc && !a.ts_utc.endsWith('Z') ? a.ts_utc + 'Z' : a.ts_utc;
            const tsB = b.ts_utc && !b.ts_utc.endsWith('Z') ? b.ts_utc + 'Z' : b.ts_utc;
            return new Date(tsB).getTime() - new Date(tsA).getTime();
          });

        if (gnssPgns.length === 0) return null;

        const latest = gnssPgns[0];
        const ts = latest.ts_utc as string;
        return {
          lat: latest.fields.lat_deg as number,
          lon: latest.fields.lon_deg as number,
          ts: ts && !ts.endsWith('Z') ? ts + 'Z' : ts,
        };
      }),
      catchError(() => throwError(() => null)),
    );
  }

  getDockmatesLivePositions(): Observable<any> {
    return this.http.get(`${this.API_URL}/community/live-positions/`);
  }

  getBorrowStatus(vesselId: string): Observable<any> {
    return this.http.get(`${this.API_URL}/vessel/${vesselId}/borrow-status/`);
  }

  getBorrowRequests(): Observable<any> {
    return this.http.get(`${this.API_URL}/vessel/borrow-requests/`);
  }

  getMyBorrowRequests(): Observable<any> {
    return this.http.get(`${this.API_URL}/vessel/my-borrow-requests/`);
  }

}
